module.exports = __webpack_public_path__ + "static/vaughanCenter2-5edfe2bda8486ebcaf94eca9641dfdbc.jpg";